module.exports = __webpack_public_path__ + "img/资讯动态.30693ef7.png";